export default {
  lychen: {
    phonetic: '\\li. kɛn\\',
    copyright: '© 2024 lychen, tous droits réservés',
  },
};
